export default __webpack_public_path__ + "static/media/IMG-20241210-WA0011.22b82026.jpg";